// extracted by mini-css-extract-plugin
export default {"footerList":"Footer_footerList__VHalg","linkList":"Footer_linkList__9IiIs","link":"Footer_link__c5ir1"};